module.exports = __webpack_public_path__ + "static/img/loading.28a250e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = 13
// module chunks = 0